module.exports = __webpack_public_path__ + "12cda2e550c78c721be3f36cb568457b.png";